import { pxToRem } from '@deltek/specification-client/core/Utilities/unitUtils'
import { makeStyles } from '@material-ui/core'

const CARD_BG_COLOR = '#FFFFFF'
const CARD_BORDER_COLOR = '#E5E7EB'
const PRIMARY_TEXT_COLOR = '#1F3A5F'
const MUTED_TEXT_COLOR = '#6B7A90'
const LABEL_COLOR = '#185E8E'
const AVATAR_BG_COLOR = '#1899D4'
const AVATAR_TEXT_COLOR = '#FFFFFF'
const ACTION_ICON_COLOR = '#1899D4'

export const useBestPracticeTipCardStyles = makeStyles((theme) => ({
    card: {
        display: 'flex',
        alignItems: 'flex-start',
        gap: theme.spacing(1),
        backgroundColor: CARD_BG_COLOR,
        border: `1px solid ${CARD_BORDER_COLOR}`,
        borderRadius: pxToRem(6),
        padding: theme.spacing(1, 1.25),
        marginBottom: theme.spacing(1),
        cursor: 'pointer',
        '&:hover': {
            backgroundColor: '#F5F8FA',
        },
    },
    cardRemoved: {
        cursor: 'default',
        '&:hover': {
            backgroundColor: CARD_BG_COLOR,
        },
    },
    cardActive: {
        borderColor: '#185E8E',
        borderLeft: `3px solid #185E8E`,
        backgroundColor: '#EEF4FB',
        '&:hover': {
            backgroundColor: '#E6F0FA',
        },
    },
    avatar: {
        width: pxToRem(28),
        height: pxToRem(28),
        borderRadius: '50%',
        backgroundColor: AVATAR_BG_COLOR,
        color: AVATAR_TEXT_COLOR,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '1.1rem',
        fontWeight: 600,
        flexShrink: 0,
    },
    body: {
        flex: 1,
        minWidth: 0,
    },
    headerRow: {
        display: 'flex',
        alignItems: 'baseline',
        justifyContent: 'space-between',
        gap: theme.spacing(1),
    },
    userName: {
        fontSize: '1.2rem',
        fontWeight: 600,
        color: PRIMARY_TEXT_COLOR,
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
    },
    timestamp: {
        fontSize: '1rem',
        color: MUTED_TEXT_COLOR,
        flexShrink: 0,
    },
    typeLabel: {
        fontSize: '1rem',
        fontWeight: 700,
        color: LABEL_COLOR,
        letterSpacing: pxToRem(0.4),
        marginTop: theme.spacing(0.5),
    },
    criteria: {
        fontSize: '1.1rem',
        color: PRIMARY_TEXT_COLOR,
        marginTop: theme.spacing(0.25),
        wordBreak: 'break-word',
    },
    criteriaLabel: {
        fontWeight: 600,
        color: LABEL_COLOR,
    },
    rightActions: {
        display: 'flex',
        alignItems: 'flex-start',
        flexShrink: 0,
        gap: theme.spacing(0.25),
    },
    actionIcon: {
        color: ACTION_ICON_COLOR,
        fontSize: pxToRem(18),
        marginTop: pxToRem(2),
    },
    moreIconBeta: {
        padding: 0,
        color: '#185E8E',
        marginTop: pxToRem(2),
    },
}))
